import { useEffect, useState } from "react";

// Rationale: THIS SHOULD BE USED FOR COMPONENTS THAT RENDER ON CLIENT ONLY!
// Possibilities:
// - Infeasible to sync between server/client (such as user settings)
// - Content changes based on effect hooks
// - Content that causes client-side hydration to fail

// Keep track of hydrate state as a global. This is used to prevent components from
// being delayed by a frame after the first `useClientOnly` `useEffect` runs.
let hasHydrated = false;

/**
 * Hook which returns true post-hydration on the client. This is generally not necessary and is best avoided.
 */
export function useClientOnly() {
  const [isClient, setHasHydrated] = useState(hasHydrated);

  useEffect(() => {
    hasHydrated = true;

    setHasHydrated(true);
  }, []);

  return isClient;
}

/**
 * Render children on the client only. This is a specialized component that should be used very sparingly.
 */
export default function ClientOnly({
  children,
}: {
  children: React.ReactNode;
}) {
  const hasMounted = useClientOnly();

  return hasMounted ? children : null;
}
